import { ReactElement } from 'react';

import { FormInstance } from 'antd';

import CheckEmail from 'components/AuthJobseeker/CheckEmail/CheckEmail';
import VerificationCode from 'components/AuthJobseeker/VerificationCode/VerificationCode';
import IntakeForm from 'components/IntakeForm/IntakeForm';

import { AuthSteps } from 'constants/enums';

interface AuthContentProps {
  authStep: AuthSteps;
  form: FormInstance;
  isLoading: boolean;
  handleCheckEmail: () => Promise<void>;
  handleSendVerificationCode: () => Promise<void>;
  handleSendRegistrationForm: (location: string) => Promise<void>;
  setAuthStep: (step: AuthSteps) => void;
}

const AuthContent = ({
  authStep,
  form,
  isLoading,
  handleCheckEmail,
  handleSendVerificationCode,
  handleSendRegistrationForm,
  setAuthStep
}: AuthContentProps): ReactElement => {
  if (authStep === AuthSteps.Login) {
    return (
      <VerificationCode
        form={form}
        isLoading={isLoading}
        onSendVerificationCode={handleSendVerificationCode}
        onCancelClick={() => setAuthStep(AuthSteps.CheckEmail)}
      />
    );
  }

  if (authStep === AuthSteps.Registration) {
    return (
      <IntakeForm
        form={form}
        onCancelClick={() => setAuthStep(AuthSteps.CheckEmail)}
        onSendRegistrationForm={handleSendRegistrationForm}
        isLoading={isLoading}
      />
    );
  }

  return (
    <CheckEmail isLoading={isLoading} handleCheckEmail={handleCheckEmail} />
  );
};

export default AuthContent;
